import { render, staticRenderFns } from "./categoryManageAction.vue?vue&type=template&id=2cfecd46&scoped=true"
import script from "./categoryManageAction.vue?vue&type=script&lang=js"
export * from "./categoryManageAction.vue?vue&type=script&lang=js"
import style0 from "./categoryManageAction.vue?vue&type=style&index=0&id=2cfecd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfecd46",
  null
  
)

export default component.exports